import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';

const AdminGuard = ({ children }) => {
  const { user, roles, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && (!user || !roles.isAdmin)) {
      navigate('/login');
    }
  }, [user, roles.isAdmin, loading, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return user && roles.isAdmin ? children : null;
};

export default AdminGuard;